import { axiosAPI, axiosOAuth, axiosOAuthNoTokenRequired, axiosLoginXl } from "./axiosClient"
import qs from "qs"
import React, { createContext } from 'react';
import axios from 'axios';
import { getParams, generateCodeVerifier, generateCodeChallenge } from '../helper/Helper';

export const UserService = {

  getToken(dataPost) {

    // https://keycloak.xlprog.dev/realms/auth-xl/protocol/openid-connect/token
    //return axiosOAuthNoTokenRequired.post(`/protocol/openid-connect/token`, new URLSearchParams(dataPost))
    return axiosOAuthNoTokenRequired.post(`/protocol/openid-connect/token`, new URLSearchParams(dataPost))
  },

  revoke(dataPost) {
    // return axiosOAuth.post(`/oauth2/revoke`, new URLSearchParams(dataPost))  // Ory Hydra
    return axiosOAuth.post(`/protocol/openid-connect/revoke`, new URLSearchParams(dataPost))
  },

  getUserInfos() {
    // return axiosOAuth.get(`/userinfo`)  // Ory Hydra
    return axiosOAuth.get(`/protocol/openid-connect/userinfo`)
  },

  postResetPassword() {
    return axiosLoginXl.post(`/utilisateur/resetpassword`)
  },

  updateEmail(dataPost) {
    return axiosLoginXl.put(`/utilisateur`, qs.stringify(dataPost))
  },

  postRapport(dataPost) {
    return axiosAPI.post(`/user/rapport`, qs.stringify(dataPost))
  },

  getUserGrants(folderId) {
    return axiosAPI.get(`${folderId}/user/grants`)
  },

/*   redirectToExternalLogin() {
    let randomNumber = Math.floor(Math.random() * (9000000000 - 1000000000 + 1) + 10)
    // window.location.href = global.config._OAUTH_PUBLIC_URL_ + "/oauth2/auth?client_id=" + global.config._OAUTH_CLIENT_ID_ + "&response_type=code&state=" + randomNumber + "&scope=openid+offline_access+stockweb+profilxl" + "&redirect_uri=" + global.config._FRONT_URL_ + "/authentication/gettoken"  // Ory Hydra
    window.location.href = global.config._OAUTH_PUBLIC_URL_ + "/protocol/openid-connect/auth?client_id=" + global.config._OAUTH_CLIENT_ID_ + "&response_type=code&state=" + randomNumber + "&scope=openid+offline_access+stockweb+profilxl" + "&redirect_uri=" + global.config._FRONT_URL_ + "/authentication/gettoken"
  }, */
  /**
   * Redirige vers l ecran de connexion Keycloak, en flux authorization_code + PKCE.
   *
   * Le client est public : il n envoie plus de client_secret. La preuve d identite
   * est apportee par PKCE, un alea a usage unique tire ici (code_verifier) dont
   * seule l empreinte SHA-256 (code_challenge) transite dans l URL. Le verifier
   * n est presente qu au moment de l echange du code, dans Gettoken.jsx.
   *
   * verifier et state sont ranges dans sessionStorage : lie a l onglet, il survit
   * a l aller-retour vers Keycloak et disparait a la fermeture de l onglet.
   *
   * Asynchrone : generateCodeChallenge s appuie sur crypto.subtle.
   */
  async redirectToExternalLogin() {
    const verifier = generateCodeVerifier()
    const challenge = await generateCodeChallenge(verifier)
    const state = generateCodeVerifier()   // meme CSPRNG, usage anti-CSRF

    sessionStorage.setItem("pkce_code_verifier", verifier)
    sessionStorage.setItem("oauth_state", state)

    const redirectUri = global.config._FRONT_URL_ + "/authentication/gettoken"
    window.location.href = global.config._OAUTH_PUBLIC_URL_
      + "/protocol/openid-connect/auth"
      + "?client_id=" + encodeURIComponent(global.config._OAUTH_CLIENT_ID_)
      + "&response_type=code"
      + "&scope=openid"
      + "&redirect_uri=" + encodeURIComponent(redirectUri)
      + "&state=" + encodeURIComponent(state)
      + "&code_challenge=" + challenge
      + "&code_challenge_method=S256"
  },

}